export default {
  sm: `
  Decreased amount of 
  greenhouse 
  gas emissions
  `,
  md: `
  Decreased amount of
  greenhouse gas emissions
  `,
  xxl: `
  Decreased amount of greenhouse 
  gas emissions
  `
};
